export const REFRESH_INTERVAL_STORAGE_KEY = 'race-analyzer-v2:refreshIntervalSec'

export const DEFAULT_REFRESH_INTERVAL_SEC = 30

export const MIN_REFRESH_INTERVAL_SEC = 1

export const MAX_REFRESH_INTERVAL_SEC = 86400

export function normalizeRefreshIntervalSec(value) {
  const parsed = parseInt(String(value), 10)
  if (!Number.isFinite(parsed)) {
    return null
  }
  if (parsed < MIN_REFRESH_INTERVAL_SEC) {
    return MIN_REFRESH_INTERVAL_SEC
  }
  if (parsed > MAX_REFRESH_INTERVAL_SEC) {
    return MAX_REFRESH_INTERVAL_SEC
  }
  return parsed
}

export function loadRefreshIntervalSec() {
  try {
    const raw = localStorage.getItem(REFRESH_INTERVAL_STORAGE_KEY)
    return normalizeRefreshIntervalSec(raw) ?? DEFAULT_REFRESH_INTERVAL_SEC
  } catch (e) {
    // Ignore storage errors
  }
  return DEFAULT_REFRESH_INTERVAL_SEC
}

export function saveRefreshIntervalSec(sec) {
  const normalized = normalizeRefreshIntervalSec(sec)
  if (normalized == null) {
    return
  }
  try {
    localStorage.setItem(REFRESH_INTERVAL_STORAGE_KEY, String(normalized))
  } catch (e) {
    // Ignore storage errors
  }
}
